import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\UpdateAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedPersonController.php
* @route '/api/planning/{event}/person/{assign_user}'
*/
const UpdateAssignedPersonController = (args: { event: string | number | { id: string | number }, assign_user: string | number | { id: string | number } } | [event: string | number | { id: string | number }, assign_user: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAssignedPersonController.url(args, options),
    method: 'put',
})

UpdateAssignedPersonController.definition = {
    methods: ["put"],
    url: '/api/planning/{event}/person/{assign_user}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Planning\UpdateAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedPersonController.php
* @route '/api/planning/{event}/person/{assign_user}'
*/
UpdateAssignedPersonController.url = (args: { event: string | number | { id: string | number }, assign_user: string | number | { id: string | number } } | [event: string | number | { id: string | number }, assign_user: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            event: args[0],
            assign_user: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
        assign_user: typeof args.assign_user === 'object'
        ? args.assign_user.id
        : args.assign_user,
    }

    return UpdateAssignedPersonController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace('{assign_user}', parsedArgs.assign_user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\UpdateAssignedPersonController::__invoke
* @see app/Http/Controllers/Planning/UpdateAssignedPersonController.php
* @route '/api/planning/{event}/person/{assign_user}'
*/
UpdateAssignedPersonController.put = (args: { event: string | number | { id: string | number }, assign_user: string | number | { id: string | number } } | [event: string | number | { id: string | number }, assign_user: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAssignedPersonController.url(args, options),
    method: 'put',
})

export default UpdateAssignedPersonController